var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-create-layout',[_c('series-form',{attrs:{"title":_vm.title,"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }